export default __webpack_public_path__ + "static/media/1.b27a6392.jpeg";